import Vue from 'vue'

import App from './App.vue'

Vue.config.productionTip = false

var moment = require('moment-business-days');
    moment = require('moment-timezone');

var mediaelement = require('vue-mediaelement');

Vue.use(require('vue-moment'), {
    moment
});

new Vue({
  render: h => h(App)
}).$mount('#app')
